export default "__VITE_ASSET__Cpga1$b5__"